import React from 'react'

import { FlexBox, type SwanStyleProps } from '@vp/swan'

import AddToCartButton from '../../shared/AddToCartButton'
import { useWorksDataContext } from '../../root/contexts/WorksDataContext'

const QuantityButtons: React.FC<SwanStyleProps> = (props) => {
  const { isPrimaryProjectWorkQuantitiesValid } = useWorksDataContext()

  return (
    <FlexBox {...props}>
      <AddToCartButton disabled={!isPrimaryProjectWorkQuantitiesValid} widthVariant="full-width" />
    </FlexBox>
  )
}

export default QuantityButtons
